import { render, staticRenderFns } from "./WordingsAdd.vue?vue&type=template&id=44bafb49&"
import script from "./WordingsAdd.vue?vue&type=script&lang=js&"
export * from "./WordingsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports